// Layout: Talent Profile
// 

JLM.MD.TalentProfile = function( container, division_type ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let header, but_shortlist, icon_shortlist, label_shortlist, gallery_figure;
	
	// Settings
	let in_shortlist = false,
		is_header_set = false,
		gallery_cache = {};
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.talent_id = null;
	INSTANCE.talent_url = null;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Get data
		INSTANCE.talent_id = parseInt( $('#jl_talent_id', container).attr('content') );
		INSTANCE.talent_url = $('#jl_talent_url', container).attr('content');
		
		// References
		let but_book, profile, gallery, but_preview, aside, biography, eventhighlights, testimonials;
		
		// Get references
		header = $('.wrap > header', container);
			but_shortlist = $('button[data-action="shortlist"]', container);
			but_book = $('button[data-action="book"]', container);
		profile = $('article .profile', container);
			gallery = $('.gallery', profile);
				gallery_figure = $('figure', gallery);
					but_preview = $('button[data-type="media"]', gallery_figure);
			aside = $('.aside', profile);
		biography = $('article .biography', container);
		eventhighlights = $('article .eventhighlights', container);
		testimonials = $('article .testimonials', container);
		
		// Gallery
		$('ul li', gallery).each(function() {
			$(this).on('click', function() {
				if ( !$(this).hasClass('selected') ) {
					// Select thumb
					$('li.selected', gallery).removeClass('selected');
					$(this).addClass('selected');
					
					// Load new image
					let image_file = $(this).attr('data-src'),
						image_src = '/img/' + INSTANCE.talent_id + '/full/' + ( JLM.retina ? 2 : 1 ) + '/' + image_file;
					loadImage( image_src );
					
					// Track
					JLM.MT.trackEvent('Image', {
						event_category: 'Media',
						event_label: JSON.stringify({
							talent: INSTANCE.talent_id,
							division: division_type,
							file: image_file
						})
					});
				}
			});
		});
		
		// Social Networks
		$('.networks li .link a', profile).each(function() {
			$(this).on('click', function() {
				JLM.MT.trackEvent('Link', {
					event_category: 'Social Network',
					event_label: JSON.stringify({
						talent: INSTANCE.talent_id,
						url: $(this).attr('href')
					})
				});
			});
		});
		
		// Media buttons
		$('button', aside).each(function() {
			let media_type = $(this).attr('data-media');
			$(this).on('click', function() {
				if ( media_type == 'audio' ) {
					launchAudioPlayer( $(this).attr('data-type') );
				} else if ( media_type == 'video' ) {
					JLM.MD.MediaPlayer.launchVideoPlayer( INSTANCE.talent_id, INSTANCE.talent_url, division_type );
				}
			});
		});
		
		// Biography expand
		if ( biography.length ) {
			let bio_title = $('h2', biography),
				bio_highlights = $('.bio_highlights', biography),
				bio_full = $('.bio_full', biography);
			
			$('button[data-action="expand"]', biography).on('click', function() {
				// Show all entries
				$(this).remove();
				bio_title.text('Career Biography');
				bio_full.show();
				bio_highlights.remove();
				
				// Track
				JLM.MT.trackEvent('Expand', {
					event_category: 'Biography',
					event_label: JSON.stringify({
						talent: INSTANCE.talent_id,
						division: division_type
					})
				});
			});
			$('button[data-action="download"]', biography).on('click', function() {
				downloadBio( $(this).data('action-type') );
			});
		}
		
		// Event Highlights expand
		if ( eventhighlights.length ) {
			$('button[data-action="expand"]', eventhighlights).on('click', function() {
				// Show all entries
				$(this).remove();
				$('.hidden', eventhighlights).removeClass('hidden');
				
				// Track
				JLM.MT.trackEvent('Expand', {
					event_category: 'Event Highlights',
					event_label: JSON.stringify({
						talent: INSTANCE.talent_id,
						division: division_type
					})
				});
			});
		}
		
		// Testimonials expand
		if ( testimonials.length ) {
			$('button[data-action="expand"]', testimonials).on('click', function() {
				// Show all entries
				$(this).remove();
				$('.hidden', testimonials).removeClass('hidden');
				
				// Track
				JLM.MT.trackEvent('Expand', {
					event_category: 'Testimonials',
					event_label: JSON.stringify({
						talent: INSTANCE.talent_id,
						division: division_type
					})
				});
			});
			$('button[data-action="download"]', testimonials).on('click', function() {
				downloadBio( $(this).data('action-type') );
			});
		}
		
		// Settings
		in_shortlist = JLM.database.isInShortlist( INSTANCE.talent_id, division_type );
		if ( in_shortlist ) addToShortlist();
		
		// Events
		but_shortlist.on('click', onToggleShortlist);
		but_book.on('click', onBookTalent);
		if ( but_preview.length ) {
			gallery_figure.on('click', function() { launchAudioPlayer(); });
			but_preview.on('click', function() { launchAudioPlayer(); });
		}
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Actions: Shortlist
	// 
	function onToggleShortlist() {
		if ( in_shortlist ) {
			removeFromShortlist();
			INSTANCE.dispatchEvent('shortlist_remove', [ INSTANCE.talent_id, division_type ]);
		} else {
			addToShortlist();
			INSTANCE.dispatchEvent('shortlist_add', [ INSTANCE.talent_id, division_type ]);
		}
	}
	function addToShortlist() {
		$('.icon svg use', but_shortlist).attr('xlink:href', '#jl_icon_shortlist_remove');
		$('.label', but_shortlist).text('Remove from Shortlist');
		but_shortlist.addClass('selected');
		in_shortlist = true;
	}
	function removeFromShortlist() {
		$('.icon svg use', but_shortlist).attr('xlink:href', '#jl_icon_shortlist_add');
		$('.label', but_shortlist).text('Add to Shortlist');
		but_shortlist.removeClass('selected');
		in_shortlist = false;
	}
	
	
	// Send to Contact page
	// 
	function onBookTalent() {
		// Track
		JLM.MT.trackEvent('Initiate', {
			event_category: 'Booking',
			event_label: JSON.stringify({
				talent: INSTANCE.talent_id,
				division: division_type
			})
		});
		
		// Go to page
		window.location.href = '/contact?talent=' + INSTANCE.talent_id + '&division=' + division_type;
	}
	
	
	// Load talent image
	// 
	function loadImage( image_src ) {
		let icon;
		
		// Create loading icon
		if ( !gallery_cache[ image_src ] ) {
			icon = new JLM.MD.IconLoading( gallery_figure );
			gallery_figure.addClass('loading');
		}
		
		// Save current image
		const image_current = $('img', gallery_figure);
		
		// Start load
		const image = new Image();
		image.onload = function() {
			gallery_cache[ image_src ] = true;
			let image_instance = $('<img src="' + image_src + '">').appendTo( gallery_figure );
			setTimeout(function() {
				if ( icon ) icon.remove();
				image_instance.addClass('reveal');
			}, 20);
			setTimeout(function() {
				image_current.remove();
			}, 500);
			gallery_figure.removeClass('loading');
		};
		image.onerror = function() {
			if ( icon ) icon.remove();
		};
		image.src = image_src;
	}
	
	
	// Download events
	// 
	function downloadBio( bio_type ) {
		// Track event
		let category = ( bio_type ? bio_type.toTitleCase() + ' ' : '' ) + 'Biography';
		JLM.MT.trackEvent('Download', {
			event_category: category,
			event_label: JSON.stringify({
				talent: INSTANCE.talent_id,
				division: division_type
			})
		});
		
		// Launch download
		var division_id = ( bio_type || division_type );
		window.location.href = JLM.MT.generateBioURL( INSTANCE.talent_id, INSTANCE.talent_url, division_id );
	}
	
	
	// Media
	// 
	function launchAudioPlayer( track_type ) {
		track_type = ( track_type || 'master' );
		JLM.MD.MediaPlayer.launchAudioPlayer( INSTANCE.talent_id, INSTANCE.talent_url, track_type );
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	INSTANCE.expand = function() {
		container.addClass('expand');
		header.addClass('set');
		is_header_set = true;
	};
	INSTANCE.contract = function() {
		container.removeClass('expand');
		setTimeout(function() {
			header.removeClass('set').css({ top: '' });
			is_header_set = false;
		}, 800);
	};
	INSTANCE.removeFromShortlist = removeFromShortlist;
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};